"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
let DisablerOverlayComponent = class DisablerOverlayComponent {
    constructor() {
        this.active = false;
        this.state = { active: false };
    }
    ngOnInit() {
        this.state.active = this.active;
        console.log(this.active ? "disablerOverlay active" : "disablerOverlay NOT active");
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DisablerOverlayComponent.prototype, "active", void 0);
DisablerOverlayComponent = __decorate([
    core_1.Component({
        selector: 'inax-disabler-overlay',
        templateUrl: './@inax/commonUi/src/disablerOverlay/disablerOverlay.component.html',
        styleUrls: ['./@inax/commonUi/src/disablerOverlay/disablerOverlay.component.css']
    }),
    __metadata("design:paramtypes", [])
], DisablerOverlayComponent);
exports.DisablerOverlayComponent = DisablerOverlayComponent;
